import React, { useState, useEffect, useCallback, useMemo } from "react";

import { useNavigate, useParams, useLocation } from "react-router-dom";
import * as Yup from "yup";
import { Form, Formik } from "formik";

import toast, { Toaster } from "react-hot-toast";
import { Container } from "react-bootstrap";

import { bankId, bGId } from "common/constants/constants";

import { getAllBankslist } from "services/bankServices";
import { getProductList } from "services/ProductsServices";

import { getSecretKey } from "./../../../services/bankServices";
import {
  getBranchProducts,
  getBranchDetail,
  updateBranchDetail,
} from "services/branchServices";

import SwiperSteps from "components/common/swiper/SwiperSteps";
import Step1 from "components/branches/editBranch/Step1";
import Step2 from "components/branches/editBranch/Step2";
import Step3 from "components/branches/editBranch/Step3";
import Loader from "components/common/loader/Loader";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import Step4 from "components/branches/editBranch/Step4";
import { encrypt } from "utils/Utils";
const EditBranch = () => {
  const { t } = useTranslation();
  const { id: branchIdParam } = useParams();
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState(1);
  const [branchDetail, setBranchDetail] = useState({});
  const [bankList, setBankList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productsInitialValue, setProductsInitialValue] = useState({});
  const [showForm, setShowForm] = useState(false);
  const bankgroupID = bGId;
  const [secretKey, setSecretKey] = useState("");
  const [swiperSteps, setSwiperSteps] = useState([
    {
      id: 1,
      name: t("branch-details"),
      isError: false,
      isCompleted: false,
    },
    {
      id: 2,
      name: t("user-details"),
      isError: false,
      isCompleted: false,
    },
    {
      id: 3,
      name: t("products"),
      isError: false,
      isCompleted: false,
    },
  ]);
  const { contactPerson = {}, branch = {}, branchUser = [] } = branchDetail;
  const {
    branchId = "",
    branchName = "",
    branchCode = "",
    branchLocation = "",
    ownedSince = "",
    userCount = "",
    b2bCount = "",
    b2cCount = "",
    balanceTotal = "",
    branchInformation = "",
  } = branch;
  const { user = {} } = branchUser[0] || {};
  const {
    contactPersonId = "",
    firstName = "",
    lastName = "",
    email = "",
    phoneNumber = "",
  } = contactPerson ? contactPerson : {};

  const handleStepError = (stepId, isError) => {
    setSwiperSteps((prev) => {
      const updatedSteps = prev.map((step) => {
        if (step.id === stepId) {
          step.isError = isError;
        }
        return step;
      });
      return updatedSteps;
    });
  };
  const handleStepCompletion = (stepId, isCompleted) => {
    setSwiperSteps((prev) => {
      const updatedSteps = prev.map((step) => {
        if (step.id === stepId) {
          step.isCompleted = isCompleted;
        }
        return step;
      });
      return updatedSteps;
    });
  };

  const navigate = useNavigate();
  const handleNext = () => {
    setCurrentTab((pre) => pre + 1);
  };
  const handleBack = () => {
    setCurrentTab((pre) => pre - 1);
  };
  const handleJump = (tabId) => {
    setCurrentTab(tabId);
  };

  const validate = Yup.object({
    firstName: Yup.string()
      .required(t("required"))
      .max(20, t("max-name-char-limit")),
    lastName: Yup.string()
      .required(t("required"))
      .max(20, t("max-name-char-limit")),
    email: Yup.string().required(t("required")).email(t("email-error")),
    userFirstName: Yup.string()
      .required(t("required"))
      .max(20, t("max-name-char-limit")),
    userLastName: Yup.string()
      .required(t("required"))
      .max(20, t("max-name-char-limit")),
    userEmail: Yup.string().required(t("required")).email(t("email-error")),
    branchName: Yup.string().required(t("required")),
    location: Yup.string().required(t("required")),
    phoneNumber: Yup.number().required(t("required")),
    bankId: Yup.string().required(t("required")),
    bankGroupId: Yup.string().required(t("required")),

    CreditEnabled: Yup.boolean(),
    creditEntityId: Yup.string(),
    sepaEnabled: Yup.boolean(),
    SepaEntityId: Yup.string(),
    accessToken: Yup.string(),
    subscriptionPrice: Yup.number().positive(t("number-validation-message")),
  });

  // Effects
  const bankListSetter = async () => {
    let result = await getAllBankslist(bankgroupID);
    if (result?.success) {
      setBankList(result.payLoad);
    }
  };

  const branchDetailHandler = async () => {
    let pathIds = {
      branchId: branchIdParam,
      bankId: location.state.bankId,
      bankgroupsId: location.state.bGId,
    };
    const result = await getBranchDetail(pathIds);
    if (result.success) {
      setBranchDetail(result.payLoad);
    }
  };

  const branchProductsHandler = async () => {
    let pathIds = {
      branchId: branchIdParam,
      bankId: location.state.bankId,
      bankgroupsId: location.state.bGId,
    };
    const result = await getBranchProducts(pathIds);

    if (result?.success) {
      const newProductList = result.payLoad.map((el) => ({
        productName: el.productKey.replaceAll("#", "_"),
        ...el,
      }));
      const productsInitialValueNew = {};
      newProductList.forEach(
        (el) =>
        (productsInitialValueNew[el.productName] =
          el.assigned === "Active" ? true : false)
      );
      setProductsInitialValue(productsInitialValueNew);
      setProductList(newProductList);
    }
  };
  const getPayloadSecretKey = async () => {
    const result = await getSecretKey();
    setSecretKey(result?.payLoad?.secret);
  };
  useEffect(() => {
    (async () => {
      await getPayloadSecretKey();
      await bankListSetter();
      await branchDetailHandler();
      await branchProductsHandler();

      setShowForm(true);
    })();
  }, []);

  const handleSubmit = async (values, resetForm) => {
    setLoading(true);
    const params = {
      bankgroupsId: location.state.bGId,
      bankId: location.state.bankId,
      branchId: branchIdParam,
    };

    const data = {
      branch: {
        branchName: values.branchName,
        branchLocation: branchLocation,
        contactPerson: {
          firstName: values.firstName,
          lastName: values.lastName,
          phoneNumber: values.phoneNumber,
          email: values.email,
        },
      },
      branchUser: {
        firstName: values.userFirstName,
        lastName: values.userLastName,
      },
      productId: Object.entries(values)
        .filter((el) => {
          return el[0].charAt(0) === "_" && el[1] === true;
        })
        .map((el) => {
          const foundProduct = productList.find(
            (product) => product.productName === el[0]
          );
          const { productId } = foundProduct;
          return productId;
        }),
      bankPayment: {
        creditEnabled: values.creditEnabled,
        creditEntityId:
          values.creditEntityId != ""
            ? encrypt(values.creditEntityId, secretKey)
            : "",
        sepaEnabled: values.sepaEnabled,
        sepaEntityId:
          values.sepaEntityId != ""
            ? encrypt(values.sepaEntityId, secretKey)
            : "",
        accessToken:
          values.accessToken != ""
            ? encrypt(values.accessToken, secretKey)
            : "",
        subscriptionPrice: values.subscriptionPrice,
      },
    };

    const response = await updateBranchDetail(params, data);
    if (response.success) {
      setLoading(false);
      toast.success(t("success-post-branch"));
      resetForm();
      navigate(`/branches/${branchIdParam}`, {
        state: location?.state?.bankId,
      });
    } else {
      setLoading(false);

      toast.error("errors...");
    }

    console.log(response);
  };
  const initialValues = {
    bankGroupId: bGId,
    bankId: bankId,
    branchName: branchName,
    location: branchLocation,
    firstName: firstName,
    lastName: lastName,
    email: email,
    userFirstName: user.firstName,
    userLastName: user.lastName,
    userEmail: user.email,
    phoneNumber: phoneNumber,

    creditEnabled: branchDetail?.bankPayment?.creditEnabled,
    creditEntityId: "",
    sepaEnabled: branchDetail?.bankPayment?.sepaEnabled,
    sepaEntityId: "",
    subscriptionPrice: branchDetail?.bankPayment?.subscriptionPrice,
    accessToken: "",
    ...productsInitialValue,
  };

  const renderCard = (formik) => {
    if (currentTab === 1) {
      return (
        <Step1
          formik={formik}
          bGId={bankgroupID}
          bankList={bankList}
          handleNext={handleNext}
          handleCompletion={handleStepCompletion}
          handleError={handleStepError}
        />
      );
    } else if (currentTab === 2) {
      return (
        <Step2
          formik={formik}
          handleNext={handleNext}
          handleBack={handleBack}
          handleCompletion={handleStepCompletion}
          handleError={handleStepError}
        />
      );
    } else if (currentTab === 3) {
      return (
        <Step3
          formik={formik}
          loading={loading}
          handleNext={handleNext}
          handleBack={handleBack}
          productList={productList}
          handleCompletion={handleStepCompletion}
          handleError={handleStepError}
        />
      );
    } else if (currentTab === 4) {
      return (
        <Step4
          formik={formik}
          loading={loading}
          handleBack={handleBack}
          productList={productList}
          handleCompletion={handleStepCompletion}
          handleError={handleStepError}
        />
      );
    }
  };

  return (
    <Container className="p-5">
      <div className="custom-breadcrumbs ">
        <span
          className="breadcrumbs-item "
          onClick={() => {
            navigate("/branches");
          }}
        >
          {t("branches")}
        </span>
        <span className="breadcrumbs-item ">{t("edit-branch")}</span>
      </div>

      <div className="d-flex justify-content-center ">
        <div className="shadow bg-body w-50 pt-3 pb-5 rounded">
          {showForm ? (
            <Formik
              initialValues={initialValues}
              validationSchema={validate}
              onSubmit={(values, { resetForm }) => {
                handleSubmit(values, resetForm);
              }}
            >
              {(formik) => {
                return (
                  <>
                    <SwiperSteps
                      list={swiperSteps}
                      tab={currentTab}
                      maxWidthSwiper={true}
                      back={handleBack}
                      next={handleNext}
                      jump={handleJump}
                    />
                    <Form className="">
                      <div className="px-5 py-2">{renderCard(formik)}</div>
                    </Form>
                  </>
                );
              }}
            </Formik>
          ) : (
            <Loader />
          )}
        </div>
      </div>
    </Container>
  );
};

export default EditBranch;
